export default __webpack_public_path__ + "static/media/249-democratic-republic-of-congo.62f7c357.svg";